import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import classNames from 'classnames';

import {
  COLOR_BLACK,
  COLOR_WHITE,
  COLOR_GREEN,
  COLOR_RED,
  COLOR_ORANGE,
} from '../../assets/styles/colors';
import { BP_MOBILE_MAX } from '../../assets/styles/breakpoints';

export const HeadingTwoSC = styled.h2`
  color: ${COLOR_BLACK};
  font-size: 37px;
  line-height: 1.35;
  font-weight: 600;
  margin-bottom: 0;
  &.white {
    color: ${COLOR_WHITE};
  }
  &.green {
    color: ${COLOR_GREEN};
  }
  &.orange {
    color: ${COLOR_ORANGE};
  }
  &.red {
    color: ${COLOR_RED};
  }
  &.bold {
    font-weight: bold;
  }
  @media (max-width: ${BP_MOBILE_MAX}px) {
    font-size: 29px;
  }
`;

const HeadingTwo = (props) => {
  const { children, className } = props;
  const customClass = classNames({ [className]: className !== '' });

  return <HeadingTwoSC className={customClass}>{children}</HeadingTwoSC>;
};

HeadingTwo.propTypes = {
  children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]).isRequired,
  className: PropTypes.string,
};

HeadingTwo.defaultProps = {
  className: '',
};

export default HeadingTwo;
